import type {
  CheckboxField as CheckboxFieldType,
  ReportFormData,
} from '@/screens/ReportCreation/reportCreation.types';
import { useController, useFormContext } from 'react-hook-form';
import { YStack } from 'tamagui';
import { FieldError } from '../FieldError';
import { CheckboxField } from './CheckboxField';

interface ControlledCheckboxFieldProps {
  field: CheckboxFieldType;
  errorMessage: string;
}

export const ControlledCheckboxField = ({
  field,
  errorMessage,
}: ControlledCheckboxFieldProps): React.ReactElement => {
  const { control } = useFormContext<ReportFormData>();
  const { field: controllerField, fieldState } = useController({
    name: field.id,
    control,
    rules: field.required ? { required: errorMessage } : undefined,
    defaultValue: false,
  });

  const checked =
    typeof controllerField.value === 'boolean' ? controllerField.value : false;

  return (
    <YStack gap="$1">
      <CheckboxField
        label={field.label}
        checked={checked}
        onCheckedChange={controllerField.onChange}
        required={field.required}
      />
      <FieldError message={fieldState.error?.message} />
    </YStack>
  );
};
